
import { Component, Vue } from 'vue-property-decorator';
import { Qiniu } from '@/types/qiniu';
import { getQiniuToken } from '@/api/third';
import { makeKey } from '@/utils/qiniu';
import { UserModule } from '@/store/modules/user';
import { addDevice, editDevice } from '@/api/device';

import OrderAddressCustom from '@/views/order/components/OrderAddressCustom.vue';
import OrderBrand from '../order/components/OrderBrand.vue';
import DialogLveReportDept from '@/components/DeptLev/index.vue';

@Component({
  name: 'DeviceADDDevice',
  components: {
    OrderAddressCustom,
    OrderBrand,
    DialogLveReportDept,
  }
})

export default class extends Vue {
  private formDevice:any = {
    id: '',
    serial: '',
    sn: '',
    name: '',
    brand: '',
    buytime: '',
    describle: '',
    address: '',
    area: '',
    imageUrl: '',
    vendorName: '',
    vendorPhone: ''
  }
  private serverCompanyId = ''
  private deviceEditData: any = {}

  private labelBrand='品牌';
  private labelProduct='类型'
  private labelModel='型号'
  private deviceLimits:any={}

  beforeCreate() {
    if (this.$route && this.$route.meta && this.$route.meta.title && this.$route.query && this.$route.query.formEdit) {
      this.$route.meta.title = '编辑设备';
    } else if (this.$route && this.$route.meta && this.$route.meta.title) {
      this.$route.meta.title = '添加设备';
    }
  }

  created() {
    this.deviceLimits = JSON.parse((this.$route as any).query.deviceLimits);
    if (UserModule.company && UserModule.company.brand_name_alias) {
      this.labelBrand = UserModule.company.brand_name_alias;
    } else {
      this.labelBrand = '品牌';
    }
    if (UserModule.company && UserModule.company.product_name_alias) {
      this.labelProduct = UserModule.company.product_name_alias;
    } else {
      this.labelProduct = '类型';
    }
    if (UserModule.company && UserModule.company.model_name_alias) {
      this.labelModel = UserModule.company.model_name_alias;
    } else {
      this.labelModel = '型号';
    }
    this.serverCompanyId = UserModule.getCompanyId;
    const params = {
      type: Qiniu.UPLOAD_TYPE_DEVICE
    };
    getQiniuToken(params).then((res) => {
      if (res && res.data) {
        this.qiniu = res.data;
      }
    });

    if (this.$route.query.formEdit && JSON.parse((this.$route as any).query.formEdit)) {
      this.deviceEditData = this.$route.query.formEdit && JSON.parse((this.$route as any).query.formEdit);
    } else {
      this.deviceEditData = {};
    }

    this.formDevice = {
      id: this.deviceEditData.id ? this.deviceEditData.id : '',
      serial: this.deviceEditData.number ? this.deviceEditData.number : '',
      sn: this.deviceEditData.sn ? this.deviceEditData.sn : '',
      name: this.deviceEditData.name ? this.deviceEditData.name : '',
      brand: this.deviceEditData.brand_name ? this.deviceEditData.brand_name : '',
      buytime: parseInt(this.deviceEditData.buy_time)>0 ? new Date(this.deviceEditData.buy_time) : '',
      describle: this.deviceEditData.describe ? this.deviceEditData.describe : '',
      address: this.deviceEditData.device_address ? this.deviceEditData.device_address : '',
      area: this.deviceEditData.device_area ? this.deviceEditData.device_area : '',
      dept_id: this.deviceEditData.dept_id ? this.deviceEditData.dept_id : '',
      dept_name: this.deviceEditData.dept_name ? this.deviceEditData.dept_name : '',
      imageUrl: this.deviceEditData.image_save_path ? this.deviceEditData.image_save_path : '',
      imgage_key: this.deviceEditData.save_parh_key ? this.deviceEditData.save_parh_key : '',
      vendorName: this.deviceEditData.manufacturer_name ? this.deviceEditData.manufacturer_name : '',
      vendorPhone: this.deviceEditData.manufacturer_phone ? this.deviceEditData.manufacturer_phone : ''
    };
    this.productBean.brand_id = this.deviceEditData.brand_id;
    this.productBean.product_id = this.deviceEditData.product_id;
    this.productBean.model_id = this.deviceEditData.model_id;
    if (this.deviceEditData.product_name) {
      if (this.deviceEditData.model_name) {
        this.formDevice.brand = this.deviceEditData.brand_name + '/' + this.deviceEditData.product_name + '/' + this.deviceEditData.model_name;
      } else {
        this.formDevice.brand = this.deviceEditData.brand_name + '/' + this.deviceEditData.product_name;
      }
    }
  }

  private brandVisible = false
  private productBean:any = {}
  private selectBrandHandle() {
    this.brandVisible = true;
  }
  private confirmBrandHandle(val: any) {
    this.productBean = val;
    this.formDevice.brand = this.productBean.brand_name;
    if (this.productBean.product_name) {
      if (this.productBean.model_name) {
        this.formDevice.brand = this.formDevice.brand + '/' + this.productBean.product_name + '/' + this.productBean.model_name;
      } else {
        this.formDevice.brand = this.formDevice.brand + '/' + this.productBean.product_name;
      }
    }
  }
  private closeBrandHandle(val: any) {
    this.brandVisible = val;
  }

  // 选择客户
  private addressCustomVisible = false
  private currentCompanyID = UserModule.getCompanyId;
  private isMultilevelRadio = true
  private selectDeviceAddressHandle() {
    this.addressCustomVisible = true;
  }
  private closeDeviceCustomHandle(value:boolean) {
    this.addressCustomVisible = value;
  }
  private saveDeviceCustomHandle(value: any) {
    this.addressCustomVisible = false;
    let oneAddress, twoAddress, threeAddress;
    if (value) {
      if (value.pBean && value.pBean1) {
        oneAddress = JSON.parse(value.pBean).address;
        twoAddress = JSON.parse(value.pBean1).address;
        threeAddress = value.address;
      } else if (value.pBean) {
        oneAddress = JSON.parse(value.pBean).address;
        twoAddress = value.address;
        threeAddress = '';
      } else {
        oneAddress = value.address;
        twoAddress = '';
        threeAddress = '';
      }
    }
    this.formDevice.address = oneAddress + twoAddress + threeAddress;
  }

  //选择部门
  private departmentLevVisible=false
  private departmentLevSelect={id:0,name:''}
  private selectReportDept() {
    this.departmentLevVisible = true;
  }
  private selectDeptLev(value:any) {
    // this.formAdd.userDept = value;
    //记录选中 
    this.departmentLevSelect = value;
    
  }
  private handleLveReportDeptConfirm() {

    this.formDevice.dept_id = this.departmentLevSelect.id ;
    this.formDevice.dept_name = this.departmentLevSelect.name ;

    this.departmentLevVisible = false;
    this.departmentLevSelect = {id:0,name:''};

  }
  private closeDialogLveReportDept() {
    this.departmentLevVisible = false;
    this.departmentLevSelect = {id:0,name:''};
  }

  // 上传图片
  private qiniu: any;
  private action = 'https://up-z1.qiniup.com';
  private form: object = {};
  handleAvatarSuccess(res: any, file: any) {
    const imgUrl = this.qiniu.default_url + res.key;
    this.formDevice.imageUrl = imgUrl;
    this.formDevice.imgage_key = res.key;
  }
  beforeAvatarUpload(file:any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }
  private confirmDevice() {
    this.addDevice();
    // this.close();
  }
  private addDevice() {
    let params:any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    params.brand_id = this.productBean.brand_id;
    params.product_id = this.productBean.product_id;
    params.model_id = this.productBean.model_id;
    params.number = this.formDevice.serial;
    params.sn = this.formDevice.sn;
    params.name = this.formDevice.name;
    if(parseInt(this.formDevice.buytime)>0){
      params.buy_time = this.formDevice.buytime / 1000;
    }
    params.describe = this.formDevice.describle;
    params.device_address = this.formDevice.address;
    params.device_area = this.formDevice.area;
    params.dept_id = this.formDevice.dept_id;
    params.dept_name = this.formDevice.dept_name;
    params.image_save_path = this.formDevice.imgage_key;
    params.manufacturer_name = this.formDevice.vendorName;
    params.manufacturer_phone = this.formDevice.vendorPhone;
    // alert(JSON.stringify(params));
    if(params.name.length>0){
      if(params.name.length>60){
        this.showErrorMsg("请输入1-60位的名称");
        return;
      }
    }
    if(params.sn.length>0){
      if(params.sn.length<6 || params.sn.length>64){
        this.showErrorMsg("请输入6-64位的sn");
        return;
      }
    }
    if(params.number.length>0){
      if(params.number.length>40){
        this.showErrorMsg("请输入1-40位的编号");
        return;
      }
    }
    if (this.formDevice && this.formDevice.id) {
      params.device_id = this.formDevice.id;
      editDevice(params).then(res => {
        this.showSecussMsg((res as any).msg);
        this.$router.go(-1);
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else { // 添加设备
      params.device_number = this.deviceLimits.device_number_limit;
      addDevice(params).then(res => {
        this.showSecussMsg((res as any).msg);
        this.$router.go(-1);
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
